import React from "react";
import HomeSlider from "../../components/HomeSlider/HomeSlider";
import SeccionFrase from "../../components/SeccionFrase/SeccionFrase";
import ComoFunciona from "../../components/ComoFunciona/ComoFunciona";
import BioFotografo from "../../components/BioFotografo/BioFotografo";
import MuroCategorias from "../../components/MuroCategorias/MuroCategorias";
import { Helmet } from "react-helmet";
import './Home.css';

const SITE = "https://juanipavlovsky.com.ar";

// 9 categorías (tus rutas reales)
const categorias = [
  { titulo: "Abstractas", url: "/galeria/abstractas", imagen: "/images/abstractas.jpg" },
  { titulo: "Retratos", url: "/galeria/almas-visibles/retratos", imagen: "/images/retratos.jpg" },
  { titulo: "En movimiento", url: "/galeria/almas-visibles/en-movimiento", imagen: "/images/en-movimiento.jpg" },
  { titulo: "Historias anónimas", url: "/galeria/almas-visibles/historias-anonimas", imagen: "/images/historias-anonimas.jpg" },
  { titulo: "Arquitectura", url: "/galeria/paisajes-urbanos/arquitectura", imagen: "/images/arquitectura.jpg" },
  { titulo: "Urbanismo", url: "/galeria/paisajes-urbanos/urbanismo", imagen: "/images/urbanismo.jpg" },
  { titulo: "Paisajes", url: "/galeria/entorno-natural/paisajes", imagen: "/images/paisajes.jpg" },
  { titulo: "Naturaleza", url: "/galeria/entorno-natural/naturaleza", imagen: "/images/naturaleza.jpg" },
  { titulo: "Fauna", url: "/galeria/entorno-natural/fauna", imagen: "/images/fauna.jpg" },
];

function Home() {
  return (
    <>
      <Helmet>
        <title>Juani Pavlovsky Fotografías</title>
        <meta name="description" content="Portfolio de Juani Pavlovsky: fotografía artística, retratos, paisajes y vinilos personalizados." />
        <link rel="canonical" href={`${SITE}/`} />
        <meta property="og:title" content="Juani Pavlovsky Fotografías" />
        <meta property="og:url" content={`${SITE}/`} />
        <link rel="preload" as="image" href="/images/abstractas.jpg" />
        <link rel="preload" as="image" href="/images/retratos.jpg" />
      </Helmet>

      {/* H1 único, oculto visualmente pero visible para SEO/lectores */}
      <h1 className="sr-only">Juani Pavlovsky Fotografías</h1>
      <div className="page-content">
        <HomeSlider />
      </div>

      <SeccionFrase />

      <MuroCategorias categorias={categorias} />

      <ComoFunciona />

      <BioFotografo />
    </>
  );
}

export default Home;
